import React from 'react';
import { ePermissions } from '../../../../types/administration/userAdministration/ePermissions';
import { ButtonTW } from '../../../../tailwindComponents/buttonTW/ButtonTW';
import { PermissionWrapper } from '../../../accessControl/PermissionWrapper';
import { UserPlusIcon } from '@heroicons/react/24/outline';
import { BodyTextTW } from '../../../../tailwindComponents/bodyText/BodyTextTW';

export const AddFeatureXButton: React.FC<{ handleAddClick: () => void; buttonText: string }> = ({
  handleAddClick,
  buttonText,
}) => {
  return (
    <PermissionWrapper allowedPermissions={[ePermissions.FeatureEdit]}>
      <ButtonTW secondary onClick={handleAddClick} className={'h-8'}>
        <div className={'flex flex-row items-center gap-2'}>
          <UserPlusIcon className={'h-4 w-4'} />
          <BodyTextTW>{buttonText}</BodyTextTW>
        </div>
      </ButtonTW>
    </PermissionWrapper>
  );
};
